import validator from "validator";
import authMessage from "../../../messages/auth";
import mobileValidator from "../../mobile";

const validateMobile = (mobile) => {
  if (validator.isEmpty(mobile)) {
    return authMessage.USER_MOBILE_DOSE_NOT_EXIST;
  }

  if (!mobile.trim().length) {
    return authMessage.USER_MOBILE_DOSE_NOT_EXIST;
  }

  if (!mobileValidator.isNumericMobile(mobile)) {
    return authMessage.USER_MOBILE_WRONG;
  }

  if (!mobileValidator.validMobileNumber(mobile)) {
    return authMessage.USER_MOBILE_WRONG;
  }

  return true;
};

const validatePassword = (password) => {
  if (validator.isEmpty(password)) {
    return authMessage.PASSWORD_DOSE_NOT_EXIST;
  }

  if (!password.trim().length) {
    return authMessage.PASSWORD_DOSE_NOT_EXIST;
  }

  const regexHasNumber = /\d/g;
  if (regexHasNumber.test(password)) {
    var regexHasLetter = /[a-zA-Z]/g;
    if (regexHasLetter.test(password)) {
      return true;
    } else {
      return authMessage.PASSWORD_MUST_HAVE_ONE_LETTER;
    }
  } else {
    return authMessage.PASSWORD_MUST_HAVE_ONE_NUMBER;
  }
};

const validateFormAddUser = (info) => {
  const resValidateMobile = validateMobile(info["mobile"]);
  if (resValidateMobile != true) {
    return resValidateMobile;
  }

  const resValidatePassword = validatePassword(info["password"]);
  if (resValidatePassword != true) {
    return resValidatePassword;
  }

  return true;
};

export default {
  validateFormAddUser,
};
